// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__9XxY7","iconsBox":"navbar_iconsBox__M032e","icon":"navbar_icon__ye8k-","iconInfo":"navbar_iconInfo__IuDgt"};